<template>
<b-row>
    <b-col>
        <template v-if="loaded === false">
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>

        </template>
        <CollectionTable v-else
            title="Local Users"
            :collection="usersCollection"
            :actions="actions"
            :globalActions="globalActions"
            :columns="columns">
            <template name="empty">
                No users available. Click <a @click="createUser">here</a> to add a new user.
            </template>
        </CollectionTable>
        <UserModal ref="userModal" :editUser="editingUser" v-model="editModal" @saved="usersCollection.fetch()"/>
        <ConfirmDeleteUser ref="deleteUserModal" v-model="deleteUserModal" @deleted="usersCollection.fetch()"/>
    </b-col>
</b-row>
</template>

<script>

import UsersCollection from '@/collections/users.js';
import UserModal from './UserModal.vue';
import CollectionTable from '@/components/CollectionTable.vue';
import ConfirmDeleteUser from './ConfirmDeleteUser.vue';

export default {
    components: {
        CollectionTable,
        UserModal,
        ConfirmDeleteUser
    },
    data() {
        return {
            usersCollection: new UsersCollection({ paginated: true }),
            editModal: false,
            deleteUserModal: false,
            editingUser: null,
            columns: [{
                label: 'Username',
                name: 'user_name',
                sortable: true,
                render(row) {
                    return row.attributes.user_name;
                }
            },{
                label: 'Role',
                name: 'role',
                sortable: true,
                render(row) {
                    return row.attributes.role
                }
            }],
            actions: [{
                name: 'edit',
                label: 'Edit',
                callback: this.editUser
            },{
                name: 'delete',
                label: 'Delete',
                callback: this.deleteUser
            }],
            globalActions: [{
                name: 'add',
                label: 'Create New User',
                callback: () => {
                    this.createUser();
                }
            }],

            loaded: false
        }
    },

    created() {
        this.usersCollection.fetch()
        .then(() => {
            this.loaded = true;
        });
    },

    methods: {
        deleteUser(rowNumber, rows) {
            const user = rows[rowNumber];
            this.$refs['deleteUserModal'].user = user;
            this.deleteUserModal = true;
        },

        createUser() {
            this.editingUser = null;
            this.editModal = true;
        },

        editUser(rowNumber, rows) {
            const user = rows[rowNumber];
            this.editingUser = user;
            this.editModal = true;
        },

        saveUser() {
            this.$refs['users'].addRow([this.username, this.isAdmin]);
            this.editModal = false;
        }
    }
}

</script>
